import React from 'react';

const addKey = (element, key) => <React.Fragment key={key}>{element}</React.Fragment>;

export default addKey;
